import { render, staticRenderFns } from "./modelTwo.vue?vue&type=template&id=36b21803&scoped=true&"
import script from "./modelTwo.vue?vue&type=script&lang=js&"
export * from "./modelTwo.vue?vue&type=script&lang=js&"
import style0 from "./modelTwo.vue?vue&type=style&index=0&id=36b21803&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b21803",
  null
  
)

export default component.exports